/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'fund-phase-merged': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3.131 8.821a11.283 11.283 0 002.826 1.333 7.317 7.317 0 00-1.803 1.32 7.319 7.319 0 00-1.59 2.37 1.333 1.333 0 11-2.462-1.023 9.985 9.985 0 012.946-3.934l.083-.066zm-.566-6.666c.368.886.909 1.692 1.59 2.37a7.3 7.3 0 004.943 2.138l.235.004H10V4l6 4-6 4V9.333h-.667a9.97 9.97 0 01-7.063-2.92A9.985 9.985 0 01.102 3.178a1.333 1.333 0 112.463-1.023z" _fill="#242628"/>'
  }
})
